// const host = 'http://192.168.100.108:8080';
const host = 'http://18.191.236.237:8080';

module.exports = host;
